import React from "react"
import {Officer} from "../../resources/application"
import {BeneficialOwnerResource} from "../../resources/beneficialOwner"
import {
	BusinessProductApplication,
	IndividualProductApplication,
	requestProductApplicationDocument,
} from "../../resources/productApplication"
import {BusinessRequestDocumentModal, IndividualRequestDocumentModal} from "./RequestDocumentModal"

export function ProductBusinessRequestDocumentModal({
	application,
	officer,
	beneficialOwners,
	close,
	onSuccess,
}: {
	application: BusinessProductApplication
	officer?: Officer
	beneficialOwners?: BeneficialOwnerResource[]
	close: () => void
	onSuccess: () => void
}) {
	return (
		<BusinessRequestDocumentModal
			applicationId={application.id}
			officer={officer}
			officerRelationshipId={application.relationships.officer?.data.id}
			beneficialOwners={beneficialOwners}
			hasOperatingAddress={!!application.attributes.operatingAddress}
			showPersonEntities={true}
			requestFn={requestProductApplicationDocument}
			close={close}
			onSuccess={onSuccess}
		/>
	)
}

export function ProductIndividualRequestDocumentModal({
	application,
	close,
	onSuccess,
}: {
	application: IndividualProductApplication
	close: () => void
	onSuccess: () => void
}) {
	return (
		<IndividualRequestDocumentModal
			applicationId={application.id}
			ssn={application.attributes.ssn}
			passport={application.attributes.passport}
			matriculaConsular={application.attributes.matriculaConsular}
			requestFn={requestProductApplicationDocument}
			close={close}
			onSuccess={onSuccess}
		/>
	)
}
